import React, { useEffect, useState } from "react";
import classes from "./Breadcrumbs.module.scss";
import BreadcrumbsOptions from "./BreadcrumbsOptions/BreadcrumbsOptions";
import ChevronRight from "../../icons/ChevronRight/ChevronRight";
import { Link } from "react-router-dom";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import SharedIcon from "../UI/SharedIcon/SharedIcon";
import { WORKSPACES } from "../../constants/workspaces";

const FOLDER = gql`
  query Folder($folderId: UUID!) {
    folder(folderId: $folderId) {
      id
      title
      description
      instruction
      approvalRequired
      approvalLevels {
        id
        name
        users {
          id
          isActive
          username
          firstName
          lastName
          email
          profile {
            imageUrl: image
          }
        }
        sequence
      }
      color {
        id
        name
      }
      parentFolder {
        id
        title
      }
      createdBy {
        profile {
          image
          role {
            id
            name
          }
        }
        id
        username
        firstName
        lastName
      }
      createdTs
      sharedFolder {
        id
        user {
          id
          email
          username
          firstName
          lastName
          profile {
            image
            role {
              id
              name
            }
          }
        }
        userRole {
          id
          name
        }
      }
      pinnedFolder {
        user {
          id
        }
        folder {
          id
          title
        }
      }
      modifiedTs
    }
  }
`;

const BreadcrumbsItem = (props) => {
  const { folder } = props;
  const folderDetails = folder[0];
  const folderTitle = folderDetails ? folderDetails.title : "";

  if (props.match.path === "/files/:folderId") {
    return (
      <div className=" d-flex">
        <ChevronRight />
        <Link
          className={classes["breadcrumbs-item-link"]}
          to={`/files/${props.match.params.folderId}`}
        >
          {folderTitle}
        </Link>
        <SharedIcon
          isFolder={true}
          itemId={props.match.params.folderId}
          showCount={true}
          rootFolders={props.rootFolders}
          sharedItems={folderDetails?.sharedFolder || []}
        />
      </div>
    );
  } else if (
    props.match.path === "/files/:folderId/:subId" ||
    props.match.path === "/files/:folderId/:subId/:docId"
  ) {
    return (
      <div className="d-flex">
        <div className=" d-flex">
          <ChevronRight />
          <Link
            className={classes["breadcrumbs-item-link"]}
            to={`/files/${props.match.params.folderId}`}
          >
            {folderDetails && folderDetails.parentFolder.title}
          </Link>
        </div>
        <div className=" d-flex">
          <ChevronRight />
          <Link
            className={classes["breadcrumbs-item-link"]}
            to={`/files/${props.match.params.folderId}/${props.match.params.subId}`}
          >
            {folderTitle}
          </Link>
          <SharedIcon
            isFolder={true}
            itemId={props.match.params.subId}
            showCount={true}
            rootFolders={props.rootFolders}
            sharedItems={folderDetails ? folderDetails.sharedFolder : []}
          />
        </div>
      </div>
    );
  }
};

const BreadcrumbsItems = (props) => {
  return (
    <div className="d-flex">
      <div className="is-size-h4">
        <Link className={classes["breadcrumbs-item-link"]} to={`/files`}>
          {WORKSPACES}
        </Link>
      </div>
      <div className="is-size-h4">
        <BreadcrumbsItem {...props} />
      </div>
    </div>
  );
};

const Breadcrumbs = (props) => {
  const [folderItem, setFolderItem] = useState([]);

  useEffect(() => {
    let folderId;
    props.subFolderId
      ? (folderId = props.subFolderId)
      : (folderId = props.rootFolderId);

    const variables = {
      folderId: folderId,
    };

    apolloClient
      .query({
        query: gql`
          ${FOLDER}
        `,
        variables: variables,
      })
      .then((result) => {
        const folder = [...result.data.folder];
        setFolderItem(folder);
      })
      .catch((e) => {
        props.history.push("/files");
      });
  }, [
    props.subFolderId,
    props.rootFolderId,
    props.history,
    props.editFolder,
    props.rootFolders,
  ]);

  return (
    <div className={[classes["breadcrumbs-container"], "d-flex"].join(" ")}>
      <BreadcrumbsItems folder={folderItem} {...props} />
      <BreadcrumbsOptions
        folder={folderItem}
        documents={props.documents}
        onApprovalAddedForAFolder={props.onApprovalAddedForAFolder}
        onFolderUpdated={props.onFolderUpdated}
        editFolder={props.editFolder}
        setEditFolder={props.setEditFolder}
        setShareFolder={props.setShareFolder}
        updateFolder={props.updateFolder}
        shareFolder={props.shareFolder}
        type={props.type}
        setShareFolders={props.setShareFolders}
        totalCheck={props.totalCheck}
        checkedShareFolder={props.checkedShareFolder}
        shareMultipleDocument={props.shareMultipleDocument}
        {...props}
      />
    </div>
  );
};

export default Breadcrumbs;
